module.exports = __webpack_public_path__ + "img/sweden-lung-cancer-male.21273abb.png";